import { useTranslation } from "react-i18next";
import classes from "../styles/blog.module.css";
import BlogDataCard from "./blogDataCard";
import RightArrow from "@public/assets/icons/rightarrow_home.svg";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import MantraUICard from "./mantraUICard";
function BlogsSection({
  blogsData,
  categoryName,
  subHeading
}) {
  const smallScreen = useMediaQuery("(max-width: 768px)");
  const {
    t
  } = useTranslation();
  const router = useRouter();
  return <div className={classes.blogsSectionContainer} data-sentry-component="BlogsSection" data-sentry-source-file="blogsSection.jsx">
      <div className={classes.blogDataText}>
        <h2 className={`${classes.blogSectionHeading} ${classes.noCopy}`}>
          {blogsData?.viewName ? blogsData?.viewName : categoryName}
        </h2>

        <div className={classes.blogSubTextContainer}>
          {(blogsData?.subHeading || subHeading) && <span className={`${classes.blogSubText} ${classes.noCopy}`}>
              {blogsData?.subHeading ? blogsData?.subHeading : subHeading}
            </span>}
          {!smallScreen && blogsData?.viewName !== "Un-categorized" && <span className={classes.viewAll} onClick={() => {
          router.push(`/blog/${blogsData?.urlExtension}`);
        }}>
              {t("View All Blogs")}
              {/* <span> */}
              <RightArrow />
              {/* </span> */}
            </span>}
        </div>
      </div>

      {!blogsData?.isMantraUI ? <div className={classes.blogDataCard}>
          {blogsData?.blogData && blogsData?.blogData.map(blogData => {
        return <div key={blogData.blogID} className={classes.cardInnerContainer}>
                  <BlogDataCard blogData={blogData} blogCategoryUrlExtension={blogsData?.urlExtension} />
                </div>;
      })}

          {smallScreen && blogsData?.viewName !== "Un-categorized" && <div className={classes.viewAll} onClick={() => {
        router.push(`/blog/${blogsData?.urlExtension}`);
      }}>
              {t("View All Blogs")}

              <RightArrow />
            </div>}
        </div> : <div>
          <div className={classes.matraListContainer}>
            {blogsData?.blogData && blogsData?.blogData.map(blogData => {
          return <div key={blogData.blogID} className={!blogsData?.isVertical ? classes.aartiListInnerContainer : classes.matraListInnerContainer}>
                    <MantraUICard blogData={blogData} blogCategoryUrlExtension={blogsData?.urlExtension}
            // isVertical={blogsData?.isVertical}
            />
                  </div>;
        })}
          </div>
          {smallScreen && blogsData?.viewName !== "Un-categorized" && <div className={classes.viewAll} onClick={() => {
        router.push(`/blog/${blogsData?.urlExtension}`);
      }}>
              {t("View All Blogs")}
              <RightArrow />
            </div>}
        </div>}
    </div>;
}
export default BlogsSection;